









































import { Picture } from '@/pages/profile/blocks/cards/components';
import ConsultationItemBlock from '@/pages/profile/views/consultations/components/ConsultationItemBlock.vue';
export default {
  name: 'ConsultationItem',
  components: { ConsultationItemBlock, Picture },
  props: {
    items: {
      type: Object as any,
      default: {},
    },
  },
  computed: {
    statusColorClass(): string {
      let color = () => {
        switch (this.items.state) {
          case 'initial': {
            return 'red';
          }
          case 'inwork': {
            return 'blue';
          }
          case 'completed': {
            return 'green';
          }
          default: {
            console.log('state - ' + this.items.state);
            return 'grey';
          }
        }
      };
      return 'card__status_' + color();
    },
    getStatus(): string {
      switch (this.items.state) {
        case 'initial': {
          return 'Новая';
        }
        case 'inwork': {
          return 'Передано в работу';
        }
        case 'completed': {
          return 'Завершена';
        }
        default: {
          console.log('state - ' + this.items.state);
          return 'Неизвестный статус';
        }
      }
    },
    getDataBySpr(): string {
      const ret = this.$store.state.consultationsTopics.find(
        (el: any) => el.id.toString() === this.items.topic_id
      );
      if (ret) {
        return ret.name ? ret.name : '';
      }
      return '';
    },
  },
  methods: {
    getLinks(requestId: any) {
      return this.items.response_files.filter((el: any) => {
        return el.response_id === requestId;
      });
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/consultations/components/ConsultationItem.vue